import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Contact from "@/components/Contact";
import { motion } from "framer-motion";
import { Star, ShieldCheck, Clock, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QuoteModal } from "@/components/QuoteModal";

export default function KontaktPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();

  return (
    <div className="min-h-screen bg-background text-foreground font-sans">
      <SEOHead 
        title="Kontakt - Easy Umzug"
        description="Wir sind jederzeit für Sie da. Fordern Sie jetzt Ihr kostenloses Angebot an."
        canonical={location.pathname}
      />
      <Navigation />
      <main className="pt-[88px]">
        <section className="py-20 md:py-32 bg-neutral-950 text-white text-center">
          <div className="container mx-auto px-4 flex flex-col items-center">
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold uppercase tracking-tight mb-6">Kontakt</h1>
            <p className="text-lg text-neutral-400 max-w-2xl mx-auto mb-8">Wir sind jederzeit für Sie da. Fordern Sie jetzt Ihr kostenloses Angebot an.</p>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8"
            >
              <QuoteModal>
                <Button size="lg" className="w-full sm:w-auto">
                  Kostenloses Angebot anfordern
                </Button>
              </QuoteModal>
              <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
                <a href="tel:+4915888640762">
                  <Phone className="w-5 h-5 mr-2" />
                  +49 15888 640762
                </a>
              </Button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="flex flex-wrap items-center justify-center gap-6 text-sm md:text-base text-neutral-200"
            >
              <div className="flex items-center gap-2">
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-current" />
                  ))}
                </div>
                <span className="font-medium">100% Kundenzufriedenheit</span>
              </div>
              <div className="flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-primary" />
                <span className="font-medium">Voll versichert</span>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="w-5 h-5 text-primary" />
                <span className="font-medium">Schnell & Zuverlässig</span>
              </div>
            </motion.div>
          </div>
        </section>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
